import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { TGermanyTicketType } from '@mopla/data-models';
import { EMlpIconTypes, EMplVariantTypes, MplIconMessage } from '@mopla/ui';

interface IStep1ResumeSubscriptionProps {
	formattedStartDate: string;
	showValidityWarning: boolean;
	daysRemaining: number;
	subscriptionType: TGermanyTicketType;
}

export const Step1ResumeSubscription: FC<IStep1ResumeSubscriptionProps> = ({
	formattedStartDate,
	showValidityWarning,
	daysRemaining,
	subscriptionType,
}) => {
	const { t } = useTranslation('dticketResumeSubscription');

	const currentMonthName = dayjs(formattedStartDate).format('MMMM');

	return (
		<Stack gap={1}>
			<Typography variant="h4-sb" color="primary.main">
				{t('step_1.title', { subscriptionType })}
			</Typography>

			<Stack gap={2}>
				<Typography variant="b2" color="solutions.600">
					{t('step_1.description', { subscriptionType })}
				</Typography>

				<Typography
					variant="b1-m"
					color="primary.main"
					data-testid="dticket-resumeStep1-startDate"
				>
					<Trans
						i18nKey="dticketResumeSubscription:step_1.active_from"
						values={{ date: formattedStartDate }}
						components={{
							bold: <strong />,
						}}
					/>
				</Typography>

				{showValidityWarning && (
					<MplIconMessage
						type={EMlpIconTypes.Warning}
						variant={EMplVariantTypes.Warning}
						dataTestid="dticket-resumeStep1-validityWarning-iconMessage"
						message={
							<Trans
								i18nKey="dticketResumeSubscription:step_1.validity_warning"
								values={{
									days: daysRemaining,
									month: currentMonthName,
								}}
								components={{
									bold: <strong />,
								}}
							/>
						}
					/>
				)}
			</Stack>
		</Stack>
	);
};
